document.addEventListener('DOMContentLoaded', function() {
  document.body.classList.remove('js-loading');
  
  const sections = document.querySelectorAll('.shopify-section');
  
  sections.forEach(function(section, index) {
    if (index === 0) {
      section.classList.add('animate-first');
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          section.classList.add('visible');
        });
      });
    } else {
      section.classList.add('animate-on-scroll');
    }
  });

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  sections.forEach(function(section, index) {
    if (index === 0) return;
    observer.observe(section);
  });
});
